// extracted by mini-css-extract-plugin
module.exports = {"full-screen":"styles_full-screen__3FWqS","vote-tools":"styles_vote-tools__1WeLS"};